'use client';

import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import useFetchProjectAudits from '../../hooks/useFetchProjectAudits';

import { ModuleRegistry } from 'ag-grid-community';
import {
  ClientSideRowModelModule,
  ClipboardModule,
  ExcelExportModule,
  ColumnMenuModule,
  ContextMenuModule,
  CellSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  RowStyleModule,
  RowSelectionModule,
  SetFilterModule,
  MultiFilterModule,
  GroupFilterModule,
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ClipboardModule,
  ExcelExportModule,
  ColumnMenuModule,
  ContextMenuModule,
  CellSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  RowStyleModule,
  RowSelectionModule,
  SetFilterModule,
  MultiFilterModule,
  GroupFilterModule,
]);

const PirateAudits = ({ onLoaded }) => {
  const { fetchProjectAudits, loadingFetchProjectAudits, errorFetchProjectAudits } = useFetchProjectAudits();
  const [projectAudits, setProjectAudits] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchProjectAudits();
        setProjectAudits(data);
        onLoaded?.();
      } catch (error) {
        console.error('Error fetching project audits:', error);
      }
    };

    fetchData();
  }, []);

  const columnDefs = [
    { headerName: 'Project Name', field: 'projectName', hide: false, editable: false },
    { headerName: 'Table Name', field: 'tableName', editable: false },
    { headerName: 'Column Name', field: 'columnName', editable: false },
    { headerName: 'Row Id', field: 'rowId', editable: false },
    { headerName: 'Old Value', field: 'oldValue', editable: false },
    { headerName: 'New Value', field: 'newValue', editable: false },
    { headerName: 'Date Modified', field: 'lastModifiedDate_CST', editable: false },
    { headerName: 'Date Day Modified', field: 'lastModifiedDay', editable: false },
    { headerName: 'Modified By', field: 'name', editable: false },
  ];

  return (
    <Box>
      {loadingFetchProjectAudits ? (
        <Box sx={{ textAlign: 'center', padding: 3 }}>
          <CircularProgress />
          <Typography variant="h6">Loading Data...</Typography>
        </Box>
      ) : errorFetchProjectAudits ? (
        <Box sx={{ textAlign: 'center', color: 'red', padding: 3 }}>
          <Typography variant="h6">Error: {errorFetchProjectAudits}</Typography>
        </Box>
      ) : (
        <Paper>
          <div style={{ height: '100vh', width: '100%' }}>
            <AgGridReact columnDefs={columnDefs} rowData={projectAudits} />
          </div>
        </Paper>
      )}
    </Box>
  );
};

export default PirateAudits;
